import linkedIn from "../../assets/icons/linkedin.svg";

const ProfileCard = ({ specialist, setActive }) => {
  return (
    <div
      className="group w-[280px] lg:w-[320px] shrink-0 bg-white rounded-2xl shadow-md p-6 text-center"
      onMouseEnter={() => setActive?.(true)}   // desktop hover
      onMouseLeave={() => setActive?.(false)}  // desktop leave
      onPointerDown={(e) => {
        if (e.pointerType === "touch") {
          setActive?.(true);                  // mobile tap
        }
      }}
      onPointerUp={(e) => {
        if (e.pointerType === "touch") {
          setActive?.(false);                 // mobile release
        }
      }}
    >
      {/* Image container */}
      <div className="relative mx-auto mb-6 w-full h-[220px] bg-[#F6F6F8] rounded-xl">
        <div
          className="absolute inset-0 clip-diagonal rounded-xl"
          style={{ backgroundColor: specialist.bgColor }}
        />

        <div className="absolute inset-x-0 bottom-0">
          <img
            src={specialist.image}
            alt={specialist.name}
            className="
              mx-auto
              w-auto
              object-contain
              grayscale
              group-hover:grayscale-0
              group-hover:scale-105
              transition-transform duration-500
              origin-bottom
            "
          />
        </div>

        {specialist.linkedIn && (
          <a
            href={specialist.linkedIn}
            target="_blank"
            rel="noopener noreferrer"
            className="
              absolute bottom-3 left-3
              p-2 rounded-full bg-white shadow
              opacity-0 scale-90 pointer-events-none
              transition-all duration-300
              group-hover:opacity-100 group-hover:scale-100 group-hover:pointer-events-auto
            "
          >
            <img src={linkedIn} className="w-6 h-6" alt="LinkedIn" />
          </a>
        )}
      </div>

      {/* Text */}
      <div className="relative h-[64px]">
        <div className="absolute inset-0 flex flex-col justify-center transition-opacity duration-300 group-hover:opacity-0">
          <h3 className="text-lg lg:text-[22px] font-medium mb-2">
            {specialist.name}
          </h3>
          <p className="text-sm lg:text-[15px] opacity-80 m-0">
            {specialist.role}
          </p>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <p className="text-sm md:text-base leading-normal">
            {specialist.quote}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
